WiseMetering.Views.EnableIntegrationConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/enable',
    title: () => i18next.t('modal.title.integration_configurations.enable'),

    save: function() {
        this.modal.block();

        this.model.enable({
            success: function() {
                WiseMetering.integrationConfigurations.fetch();
                WiseMetering.layout.showTipper('success', i18next.t('ui.successfully_saved'));
                this.modal.close();
            }.bind(this),
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON?.error || i18next.t('ui.unspecified_error');
                WiseMetering.layout.showTipper('error', errorMessage);
                this.modal.unblock();
            }.bind(this)
        });
    }
});
